import { LocalNotificationSchema } from "@capacitor/local-notifications";

export const INVALID_USER_ID = "INVALID USER ID";

class User {
  id: string;
  displayName: string;
  isAdmin: boolean;
  isModerator: boolean;
  isTester: boolean;
  email: string;
  isAnonymous: boolean;
  phoneNumber: string;
  photoURL: string;
  description: string;
  location: any;
  profileURL: string;
  authProvider: any;
  missions: string[];
  notifications: LocalNotificationSchema[];
  badges: string[];

  constructor(
    id: string,
    displayName: string,
    isAdmin: boolean,
    isModerator: boolean,
    isTester: boolean,
    email: string,
    isAnonymous: boolean,
    phoneNumber: string,
    photoURL: string,
    description: string,
    location: any,
    profileURL: string,
    authProvider: any,
    missions: string[],
    notifications: LocalNotificationSchema[],
    badges: string[]
  ) {
    this.id = id;
    this.displayName = displayName;
    this.isAdmin = isAdmin;
    this.isModerator = isModerator;
    this.isTester = isTester;
    this.email = email;
    this.isAnonymous = isAnonymous;
    this.phoneNumber = phoneNumber;
    this.photoURL = photoURL;
    this.description = description;
    this.location = location;
    this.profileURL = profileURL;
    this.authProvider = authProvider;
    this.missions = missions;
    this.notifications = notifications;
    this.badges = badges;
  }
}

export type TesterEmailCheck = {
  emailFound: boolean;
  userId: string;
  retrieveError: string;
};

export type TesterUserIds = {
  userIds: string[];
};

export type TesterUserEmails = {
  emails: string[];
};

export default User;
